module.exports = __webpack_public_path__ + "img/custom2.250cf059.png";